// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__VNie0","footer":"ModalInfo_footer__3qHe8"};